import { buttonWhite, buttonOrange } from '@assets/styles/helpers/colors.styles'

interface GetIconButtonStylesProps {
  color: 'primary' | 'secondary' | 'tertiary'
  variant?: 'text' | 'contained'
}

export const getIconButtonStyles = (props: GetIconButtonStylesProps) => {
  const { color, variant } = props
  switch (variant) {
    case 'text':
      switch (color) {
        case 'primary':
          return {
            backgroundColor: buttonWhite.text.background,
            border: 'none',
            color: buttonWhite.text.font,
            '&.Mui-disabled': {
              color: buttonWhite.text.fontDisabled
            },
            '&:hover': {
              color: buttonWhite.text.fontHover
            },
            '&:active': {
              color: buttonWhite.text.fontActive
            }
          }
        case 'secondary':
          return {
            backgroundColor: buttonOrange.text.background,
            border: 'none',
            color: buttonOrange.text.font,
            '&:hover': {
              color: buttonOrange.text.fontHover
            },
            '&:active': {
              color: buttonOrange.text.fontActive
            },
            '&.Mui-disabled': {
              color: buttonOrange.text.fontDisabled
            }
          }
        case 'tertiary':
          return {
            backgroundColor: buttonWhite.text.background,
            border: 'none',
            color: buttonWhite.text.fontActive,
            '&:hover': {
              color: buttonWhite.text.fontActive
            },
            '&:active': {
              color: buttonWhite.text.fontDisabled
            },
            '&.Mui-disabled': {
              color: buttonWhite.text.fontDisabled
            }
          }
        default:
          return {
            backgroundColor: buttonWhite.text.background,
            border: 'none',
            color: buttonWhite.text.font,
            '&.Mui-disabled': {
              color: buttonWhite.text.fontDisabled
            },
            '&:hover': {
              color: buttonWhite.text.fontHover
            },
            '&:active': {
              color: buttonWhite.text.fontActive
            }
          }
      }
    case 'contained':
      switch (color) {
        case 'primary':
          return {
            backgroundColor: buttonWhite.contained.background,
            border: 'none',
            color: buttonWhite.contained.font,
            '&.Mui-disabled': {
              backgroundColor: buttonWhite.contained.backgroundDisabled
            },
            '&:hover': {
              backgroundColor: buttonWhite.contained.background
            },
            '&:active': {
              backgroundColor: buttonWhite.contained.backgroundActive
            }
          }
        case 'secondary':
          return {
            backgroundColor: buttonOrange.contained.background,
            border: 'none',
            color: buttonOrange.text.font,
            '&:hover': {
              backgroundColor: buttonOrange.contained.backgroundHover
            },
            '&:active': {
              backgroundColor: buttonOrange.contained.backgroundActive
            },
            '&.Mui-disabled': {
              backgroundColor: buttonOrange.contained.backgroundDisabled
            }
          }
        case 'tertiary':
          return {
            backgroundColor: buttonWhite.contained.background,
            border: 'none',
            color: buttonWhite.contained.font,
            '&.Mui-disabled': {
              backgroundColor: buttonWhite.contained.backgroundDisabled
            },
            '&:hover': {
              backgroundColor: buttonWhite.contained.background
            },
            '&:active': {
              backgroundColor: buttonWhite.contained.backgroundActive
            }
          }
        default:
          return {
            backgroundColor: buttonWhite.contained.background,
            border: 'none',
            color: buttonWhite.contained.font,
            '&.Mui-disabled': {
              backgroundColor: buttonWhite.contained.backgroundDisabled
            },
            '&:hover': {
              backgroundColor: buttonWhite.contained.background
            },
            '&:active': {
              backgroundColor: buttonWhite.contained.backgroundActive
            }
          }
      }
    default:
      return {
        backgroundColor: buttonWhite.text.background,
        border: 'none',
        color: buttonWhite.text.font,
        '&.Mui-disabled': {
          color: buttonWhite.text.fontDisabled
        },
        '&:hover': {
          color: buttonWhite.text.fontHover
        },
        '&:active': {
          color: buttonWhite.text.fontActive
        }
      }
  }
}
